<template>
  <div>
    <button @click="handler" ref="btn">{{ name }}</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "初始值",
    };
  },
  mounted() {
    setTimeout(function () {
      console.log("1");
    });
    new Promise(function (resolve) {
      console.log("2");
      resolve();
    }).then(function () {
      console.log("3");
    });
    console.log("4");
  },
  methods: {
    handler() {
      this.name = "改变了啊";
      console.log("this.name", this.name);
      console.log("this.$refs.btn.innerHTML", this.$refs.btn.innerHTML);
      this.$nextTick(() => {
        console.log("this.$refs.btn.innerHTML", this.$refs.btn.innerHTML);
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>